// extracted by mini-css-extract-plugin
export default {"root":"ButtonDaub_root__wMs+C"};